const RecipeAPI = {
  getRecipes () {
    return new Promise((resolve, reject) => {
      const response = fetch('/static/api/recipe.php', {
        method: 'POST'
      })
	    .then(response => response.json())
	    resolve(response)
    })
  }
}
export default RecipeAPI



// WEBPACK FOOTER //
// ./src/api/recipe.js